import AnchorDecorator from "./anchor";
import LinkDecorator from "./link";
const nodeViewDecorators = [
  LinkDecorator,
  AnchorDecorator
];
export {
  nodeViewDecorators
};
//# sourceMappingURL=index.js.map
